import React, { useEffect, useMemo } from 'react';
import EmojiCard from './EmojiCard';
import VerticalBar from './VerticalBar';
import { Select } from 'antd';
import { useState } from 'react';
import { Tabs } from 'antd';
import images from '../../../themes/appImage'
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { averageMoodLoad, thoughtsLoggedLoad } from '../../../redux/slices/dash.slice';

const { Option } = Select;


const ThoughtChart = ({ orgId, tab, department }) => {
  let data = moment().month();
  const [month, setMonth] = useState(data)
  const currentDate = new Date();
  const firstDayOfMonth = new Date(Date.UTC(currentDate.getFullYear(), month, 1));
  const lastDayOfMonth = new Date(Date.UTC(currentDate.getFullYear(), month + 1, 0, 23, 59, 59));

  const averageData = {
    logType: "thoughts",
    startDate: firstDayOfMonth.toISOString(),
    endDate: lastDayOfMonth.toISOString(),
    organisation: orgId
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (tab == 2) {
      const payload = {
        month: month,
        organisation: orgId,
        ...(department && { department }),
      }
      dispatch(thoughtsLoggedLoad(payload));
      dispatch(averageMoodLoad({ ...averageData, ...(department && { department }) }));
    }
  }, [month, dispatch, tab, department, orgId]);

  const mydata = useSelector((state) => state.dashboardReducer) || {};
  const thoughtsData = mydata?.thoughtsData;
  const averageMoodData = mydata?.averageData;
  const averageThoughtName = averageMoodData?.averageThoughtName;
  const percentageChange = averageMoodData?.percentageChange;

  const thoughtImageMap = {
    veryPositive: images.veryPositive,
    "Very Positive": images.veryPositive,
    positive: images.postive,
    "Positive": images.postive,
    neutral: images.neutral,
    "Neutral": images.neutral,
    negative: images.negative,
    "Negative": images.negative,
    veryNegative: images.veryNegative,
    "Very Negative": images.veryNegative,
  };
  const thoughtImage = averageThoughtName ? thoughtImageMap[averageThoughtName] || null : null;

  let totalSum = 0;
  for (const key in mydata.thoughtsData) {
    if (key !== "_id") {
      totalSum += mydata?.thoughtsData[key];
    }
  }

  const moodData = useMemo(() => {
    return [
      { percentage: `${(totalSum !== 0 ? (mydata?.thoughtsData.veryPositive / totalSum) * 100 : 0)}`, imageSource: images.veryPositive, altText: "veryPositive" },
      { percentage: `${(totalSum !== 0 ? (mydata?.thoughtsData.positive / totalSum) * 100 : 0)}`, imageSource: images.postive, altText: "positive" },
      { percentage: `${(totalSum !== 0 ? (mydata?.thoughtsData.neutral / totalSum) * 100 : 0)}`, imageSource: images.neutral, altText: "neutral" },
      { percentage: `${(totalSum !== 0 ? (mydata?.thoughtsData.negative / totalSum) * 100 : 0)}`, imageSource: images.negative, altText: "negative" },
      { percentage: `${(totalSum !== 0 ? (mydata?.thoughtsData.veryNegative / totalSum) * 100 : 0)}`, imageSource: images.veryNegative, altText: "veryNegative" }
    ];
  }, [mydata?.thoughtsData]);
  console.log(moodData, "moodData");
  const handleMonthChange = (value) => {
    console.log("the value of month is", value);
    setMonth(value);
  };

  return (
    <div>
      <div className='flex justify-between lg:flex-col lg:items-center gap-3 w-[100%]'>
        <div className='w-[70%] pb-2'>
          <div className='flex items-center justify-between months-selector'>
            <div></div>
            <div className='w-[100px]'>
            <Select defaultValue={month.toString()} onChange={handleMonthChange}>
              <Option value="0">January</Option>
              <Option value="1">February</Option>
              <Option value="2">March</Option>
              <Option value="3">April</Option>
              <Option value="4">May</Option>
              <Option value="5">June</Option>
              <Option value="6">July</Option>
              <Option value="7">August</Option>
              <Option value="8">September</Option>
              <Option value="9">October</Option>
              <Option value="10">November</Option>
              <Option value="11">December</Option>
            </Select>
            </div>
          </div>
          <div className='flex gap-2 h-[300px] items-end px-[15px] justify-evenly'>
            {moodData.map((mood, index) => (
              <VerticalBar
                key={index}
                barPercentage={Number(mood.percentage) > 100 ? "100%" : Number(mood.percentage) < 18 ? "18%" : (mood.percentage) + "%"}
                textPercentage={Math.floor(Number(mood.percentage)) + "%"}
                imageSource={mood.imageSource}
                altText={mood.altText}
              />
            ))}
          </div>
        </div>
        <div className='w-[30%] flex mb-2'>
          <EmojiCard
            moodImage={thoughtImage}
            moodDescription={averageThoughtName}
            percentageChange={percentageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ThoughtChart;
